import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { GdprClauseType, GdprLanguage } from '@/features/settings/api/types/gdpr';

export const useUpdateGdprClauseValidationSchema = () => {
  const { t } = useTranslation(['settings', 'validation']);

  return z.object({
    gdprClause: z
      .string()
      .min(10, t('settings:gdpr.gdprClauseMinText'))
      .max(10000, t('settings:gdpr.gdprClauseMaxText')),
    language: z.nativeEnum(GdprLanguage),
    type: z.nativeEnum(GdprClauseType),
  });
};
